export default "__VITE_ASSET__ROTIcdyK__"